import React from 'react';
import { UPLOAD_COMPLETED_PERCENT } from '@components-member/shared/DropzoneDocumentPreview/constants';
import { Progress } from 'antd';
import DocumentIcon from 'assets/icons/documentIcon.svg';
import TrashIcon from 'assets/icons/trash icon.svg';
import styles from './documentPreview.styles.module.scss';

interface IDocumentPreviewProps {
  fileName: string;
  onDeleteHandler: () => void;
  progress?: number;
}

export const DocumentPreview = (props: IDocumentPreviewProps) => {
  const { fileName, progress, onDeleteHandler } = props;

  return (
    <div className={styles.documentPreview}>
      <svg className={styles.documentPreviewDocumentIcon} viewBox="0 0 20 20">
        <use xlinkHref={DocumentIcon} />
      </svg>

      <div className={styles.documentPreviewBody}>
        <span>{fileName}</span>

        {progress !== UPLOAD_COMPLETED_PERCENT && progress !== undefined && (
          <Progress showInfo={false} className={styles.progress} size="small" strokeLinecap="butt" percent={progress} />
        )}
      </div>

      <svg className={styles.documentPreviewTrashIcon} viewBox="0 0 20 20" onClick={onDeleteHandler}>
        <use xlinkHref={TrashIcon} />
      </svg>
    </div>
  );
};
